import axiosInstance from './axiosInstance'

export const getProjectProductionPOById = (id) => {
  return axiosInstance.get(`/project-production-pos/${id}`)
}

export const getProjectProductionPOsByProjectId = (projectId) => {
  return axiosInstance.get(`/project-production-pos/?projectId=${projectId}`)
}

// export const getProjectProductionPOs = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/project-production-pos?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createProjectProductionPO = (data) => {
  return axiosInstance.post('/project-production-pos', data)
}

export const updateProjectProductionPO = (id, data) => {
  return axiosInstance.put(`/project-production-pos/${id}`, data)
}

export const deleteProjectProductionPO = (id) => {
  return axiosInstance.delete(`/project-production-pos/${id}`)
}
